<template>
  <div>
    <div class="elasticComputeCloudResourceAzure-title">
      <div>{{ $t("RAM.Azure.VirtualMachine.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:elasticComputeCloudResourceAzure:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:elasticComputeCloudResourceAzure:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticComputeCloudResourceAzure-top">
      <elastic-compute-cloud-resource-azure-search
        ref="elasticComputeCloudResourceAzureSearchChild"
      ></elastic-compute-cloud-resource-azure-search>
    </div>
    <table-elastic-compute-cloud-resource-azure></table-elastic-compute-cloud-resource-azure>
  </div>
</template>

<script>
import ElasticComputeCloudResourceAzureSearch from "../ec2/ElasticComputeCloudResourceAzureSearch";
import TableElasticComputeCloudResourceAzure from "../ec2/TableElasticComputeCloudResourceAzure";

export default {
  name: "ElasticComputeCloudResourceAzure",
  components: {
    ElasticComputeCloudResourceAzureSearch,
    TableElasticComputeCloudResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchIDVal: "",
      instanceNameSearchIDVal: "",
      companyId: "",
      publicIpSearchIDVal: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.elasticComputeCloudResourceAzureSearchChild.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 201
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchIDVal = this.$refs.elasticComputeCloudResourceAzureSearchChild.accountName;
      this.instanceNameSearchIDVal = this.$refs.elasticComputeCloudResourceAzureSearchChild.instanceName;
      this.publicIpSearchIDVal = this.$refs.elasticComputeCloudResourceAzureSearchChild.publicIp;
      this.companyId = this.$refs.elasticComputeCloudResourceAzureSearchChild.companyId;

      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureInstance({
          companyId: this.companyId,
          accountName: this.accountNameSearchIDVal,
          instanceName: this.instanceNameSearchIDVal,
          publicIp: this.publicIpSearchIDVal
        })
        .then(res => {
          let fileName = this.$t('RAM.export.azureVirtualMachine');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.elasticComputeCloudResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticComputeCloudResourceAzure-title > div:nth-child(1) {
  float: left;
}
.elasticComputeCloudResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticComputeCloudResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/ec2/ElasticComputeCloudResourceAzure.vue